import React from 'react';
import { Badge } from 'primereact/badge';

export interface NotificationBadgeAtomProps {
  count: number;
  max?: number;
  severity?: 'danger' | 'info' | 'success' | 'warning';
  className?: string;
}

/**
 * NotificationBadgeAtom - Displays a count badge for notifications
 * Uses PrimeReact Badge component directly
 */
const NotificationBadgeAtom: React.FC<NotificationBadgeAtomProps> = ({
  count,
  max = 99,
  severity = 'danger',
  className = ''
}) => {
  if (count <= 0) {
    return null;
  }

  const displayValue = count > max ? `${max}+` : count.toString();

  return (
    <Badge
      value={displayValue}
      severity={severity}
      className={className}
    />
  );
};

export default NotificationBadgeAtom;